import { render, staticRenderFns } from "./ConfirmationRequirements.vue?vue&type=template&id=ae878626&scoped=true&"
import script from "./ConfirmationRequirements.vue?vue&type=script&lang=js&"
export * from "./ConfirmationRequirements.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationRequirements.vue?vue&type=style&index=0&id=ae878626&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae878626",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VContainer})
